<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">Clientes</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          :tabla="sNombreTabla"
          :Detalles="'DetalleClientes'"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'idClientes'"
          :bShowMapDetails="false"
          :bActiveNew="true"
          :aInfoTBDetalleExp="aDetallesExport"
          @idSelect="onCargarIdSelect"
          @nameField="onCargarNombreSelect"
        >
        </grid>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0 white titlesdark--text" v-if="parseInt(nIdSeleccionado) != 0">
      <v-col md="8" sm="8" class="pa-0 ma-4" >
          <span class="title titlesdark--text font-weight-bold pl-1">Proyectos por Cliente</span>
      </v-col>
       <v-col md="4" sm="4" class="pa-0 ma-4">
        
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid-detalle
            v-if="parseInt(nIdSeleccionado) != 0"
            :tabla="'ClientesProyectos'"
            :sIdTable="'idClientesProyectos'"
            :bActiveFilter="false"
            :bActiveExport="false"
            :bSingleSelect="false"
            :bShowSelect="false"
            :bShowMapDetails="false"
            :bActiveSearch="false"
            :bGridDetalle="true"
            :bGridAnidada="false"
            :nIdValor="parseInt(nIdSeleccionado)"
            :sCampoFiltro="'idClientes'"
          />
      </v-col>
    </v-row>
    <ModalExterno
      :bShowModal="bShowModal"
      :sTable="sTableModal"
      :sTitle="sTitleModal"
      @input="changeStateModal">
    </ModalExterno>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import GridDetalle from '@/components/Grid/Grid.vue'
import ModalExterno from '@/components/ModalExterno.vue'
export default {
  name:"Clientes",
  components: {
    grid,
    GridDetalle,
    ModalExterno,
  },
  data() {
    return {
      nIdSeleccionado: 0,                  // Id seleccionado
      sNombreCampoFiltro: '',                 // Nombre del campo foreignKey
      bShowModal: false,             // Habilita o deshabilita modal externo
      sTableModal: '',               // Nombre tabla a trabajar sobre el modal
      sTitleModal: '',               // Titlulo del modal
      sNombreTabla: 'Clientes',
      aDetallesExport : [
        { 
          sTablaDetalle: 'ClientesProyectos',
          sNombreCampoFiltroDetalle: 'idClientes',
          sCampoParaFiltroTBPrincipal: 'idClientes',
        }
      ],
      aItemsBreadcrumbs: [
        {
          text: 'Inicio',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Control de licencias',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Clientes',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      mostrarFormularioNuevo : false,
      nKeyReset : 0,
    }
  },// fin data
  methods: {
    changeStateModal(bNewValue) {
      this.bShowModal = bNewValue;
    },
    onCargarIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    onCargarNombreSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    onMostarModal() {
      this.mostrarFormularioNuevo = true
      this.nKeyReset++
    }
  },
}
</script>

<style scoped>

</style>